module.exports = {
  platform: 'voice',
  name: 'jump',
  node: 'jump',
  bg: '#FFFFFF',
  note: '',
  property: {
    type: 'component', // component, exit_page, break_loop
    component: ''
  }
}
